// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"bf215c11","140":"4e964ea0","245":"a871c620","588":"3233a959","744":"51ad53d4","761":"57e37a9e","818":"fd70a547","920":"3f3f38c5"}[chunkId] + ".chunk.js";
};